import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const getters = {
  redirectUrl: state => state.redirectUrl,
};

const mutations = {
  setRedirectUrl: (state, redirectUrl) => { state.redirectUrl = redirectUrl; },
};

const state = {
  redirectUrl: null,
};

const actions = {
  setRedirectUrl: (context, redirectUrl) => {
    context.commit('setRedirectUrl', redirectUrl);
  },

  clearRedirectUrl: (context) => {
    context.commit('setRedirectUrl', null);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./app/src/store/modules/route.js